angular.module('v3sWbtPlayerApp').factory('v3sTestingLogService', ["$timeout", "v3sServiceFinder", function ($timeout, v3sServiceFinder) {

    var v3sNavigationService = v3sServiceFinder.get("v3sNavigationService");
    var v3sAnimationService = v3sServiceFinder.get("v3sAnimationService");

    var wbt, testingLogsId, testingLogs, lastActorId;
    var running = false;
    var describing = false;
    var descriptionIndex = 0;
    var updateTextTimeout;

    function pushTestingLog(log) {
        testingLogs += log + "\n";
    }

    function resetAndReload() {
        localStorage.setItem(testingLogsId, testingLogs);
        if (v3sNavigationService) v3sNavigationService.resetAndReload();
    }

    function startDescribing(title) {
        endDescribing(true);
        describing = true;
        title = title.replace(/"/g, '\\"');
        pushTestingLog('describe("Fall: ' + title + '", () =>{ ');
    }

    function endDescribing(reload) {
        if (describing) {
            pushTestingLog('});\n');
            describing = false;

            if (reload) {
                resetAndReload();
            }
        }
    }

    function addDescription(title, body) {
        title = title.replace(/"/g, '\\"');
        var description = 'it("' + title + '", async ()=>{\n ' + body + '\n })';
        pushTestingLog(description);
        console.log(descriptionIndex++);
    }

    
    if (v3sNavigationService) {
        v3sNavigationService.subscribeWbtDataInited(function (event, _wbt) {
            wbt = _wbt;
            testingLogsId = "v3sTestingLogs-" + wbt.id;
            var logs = localStorage.getItem(testingLogsId);

            if (!!logs) {
                testingLogs = logs;
                running = true;
                console.log("Testing recording in progress...");
            }
        });

        v3sNavigationService.subscribeCurrentPageChanged(function (event, page) {
            if (running) {
                startDescribing(page.title);
                addDescription(
                    'Zur Seite [' + page.title + '] navigieren',
                    'await browser.restart();\n await wbtp.goTo("' + page.getSco().id + '", "' + page.id + '");',
                    true);
            }
        });
    }
    
    if (v3sAnimationService) {
        v3sAnimationService.subscribeAnimationTweenCompleted(function (event, action) {
            if (!!action.actor && running && lastActorId != action.actor) {
                lastActorId = action.actor;
                if (updateTextTimeout && $timeout.cancel(updateTextTimeout)) console.log("Error! You clicked to fast!");

                updateTextTimeout = $timeout(function () {
                    return addDescription(
                        document.getElementById(action.actor).textContent.trim(),
                        'await checkStatusChange("#' + action.actor + '", "' + document.querySelector("v3s-text[v3s-name='result']").textContent.trim() + '");');
                }, 300);
            }
        });
    }

    window.v3sTesting = {
        start: function () {
            testingLogs = "\n\n";
            running = true;
            resetAndReload();
        },
        end: function () {
            endDescribing(false);
            running = false;
            localStorage.removeItem(testingLogsId);
            return 'describe("' + wbt.title + ' Testing", () =>{\n beforeAll(async () => { await wbtp.start("' + wbt.title + '");});\nbeforeEach(async () => { await wbtp.clickAnywhere();});\n' + testingLogs + '\n});'
        }
    };

    return {
        pushTestingLog: pushTestingLog
    }
}]);



